export const ACCOUNT_ORDERS_ROUTE = "orders";
export const ACCOUNT_PROFILE_ROUTE = "profile";
export const ORDER_TRACKING_ROUTE = "/account/orders/orderTraking";
export const ORDERS_ROUTE = "/account/orders"
